(function () {
    'use strict';

    angular
        .module("skillsApp")
        .directive("skillsFilter", skillsFilter);

    function skillsFilter() {
        return {
            templateUrl: "/app/directives/skills-filter.tpl.html",
            restrict: "E",
            scope: {
                reloadQualities: "&",
                filterValues: "=",
                assignedToValue: "@",
                statusValue: "@",
                connectedValue: "@",
                doesNotApplyValue: "@",
            },
            controller: SkillsFilterController,
            controllerAs: 'vm'
        };

        function SkillsFilterController($scope, $translate) {
            var vm = this;

            if ($scope.assignedToValue !== undefined && ($scope.assignedToValue === "all" || $scope.assignedToValue === "function" || $scope.assignedToValue === "individual")) {
                vm.assignedToOptions = [{ label: $translate.instant($scope.assignedToValue), value: $scope.assignedToValue }];
            } else {
                vm.assignedToOptions = [
                    { label: $translate.instant("function_and_individual"), value: "all" },
                    { label: $translate.instant("function"), value: "function" },
                    { label: $translate.instant("individual"), value: "individual" }
                ];
            }

            if ($scope.statusValue !== undefined && ($scope.statusValue === "all" || $scope.statusValue === "approved" || $scope.statusValue === "notApproved")) {
                vm.statusOptions = [{ label: $translate.instant($scope.statusValue), value: $scope.statusValue }];
            } else {
                vm.statusOptions = [
                    { label: $translate.instant("all"), value: "all" },
                    { label: $translate.instant("approved"), value: "approved" },
                    { label: $translate.instant("not_approved"), value: "notApproved" }
                ];
            }

            if ($scope.connectedValue !== undefined && ($scope.connectedValue === "no" || $scope.connectedValue === "yes" || $scope.connectedValue === "both")) {
                vm.connectedOptions = [{ label: $translate.instant($scope.connectedValue), value: $scope.connectedValue }];
            } else {
                vm.connectedOptions = [
                    { label: $translate.instant("yes"), value: "yes" },
                    { label: $translate.instant("no"), value: "no" },
                    { label: $translate.instant("both"), value: "both" }
                ];
            }

            if ($scope.doesNotApplyValue !== undefined && ($scope.doesNotApplyValue === "no" || $scope.doesNotApplyValue === "yes" || $scope.doesNotApplyValue === "both")) {
                vm.doesNotApplyOptions = [{ label: $translate.instant($scope.doesNotApplyValue), value: $scope.doesNotApplyValue }];
            } else {
                vm.doesNotApplyOptions = [
                    { label: $translate.instant("no"), value: "no" },
                    { label: $translate.instant("yes"), value: "yes" },
                    { label: $translate.instant("both"), value: "both" }
                ];
            }

            function init() {
                vm.assignedTo = vm.assignedToOptions[0];
                vm.status = vm.statusOptions[0];
                vm.connected = vm.connectedOptions[0];
                vm.doesNotApply = vm.doesNotApplyOptions[0];

                $scope.filterValues = {
                    assignedTo: vm.assignedTo.value,
                    status: vm.status.value,
                    connected: vm.connected.value,
                    doesNotApply: vm.doesNotApply.value
                };
            }
            init();

            vm.setValue = function (typeObject, obj) {
                if (typeObject === "assignedTo") {
                    $scope.filterValues.assignedTo = obj.value;
                }
                if (typeObject === "status") {
                    $scope.filterValues.status = obj.value;
                }
                if (typeObject === "connected") {
                    $scope.filterValues.connected = obj.value;
                }
                if (typeObject === "doesNotApply") {
                    $scope.filterValues.doesNotApply = obj.value;
                }

                if ($scope.reloadQualities()) {
                    $scope.reloadQualities()();
                }
            };
        }
    }
})();